export enum FormaEntrega {
  RETIRADA = 'retirada',
  ENTREGA = 'entrega'
}
